module.exports = __webpack_public_path__ + "img/c7d4bb2eed0c5b2d120f4aeb0b065fdf.png";